import { create } from "zustand";

type RestrictedFeatureState = {
  actionTriggerNeedCore: boolean;
  actiontriggerNeedNetwork: boolean;
  actionTriggerModalTrialModal: boolean;
};

export const restrictedFeatureState = create<RestrictedFeatureState>(() => ({
  actionTriggerNeedCore: false,
  actiontriggerNeedNetwork: false,
  actionTriggerModalTrialModal: false,
}));

export const setActionTriggerNeedCore = (trigger: boolean) =>
  restrictedFeatureState.setState(() => ({ actionTriggerNeedCore: trigger }));

export const setActionTriggerNeedNetwork = (trigger: boolean) =>
  restrictedFeatureState.setState(() => ({
    actiontriggerNeedNetwork: trigger,
  }));

export const setActionTriggerModalTrialModal = (trigger: boolean) =>
  restrictedFeatureState.setState(() => ({
    actionTriggerModalTrialModal: trigger,
  }));
